module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tocx"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780804787161_03_preface"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780804787161_06_ch1"
    }
  }, [_vm._v("1. EVOLUTIONARY ECOLOGY, INTERACTION, AND COEVOLUTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780804787161_06_ch1#sec1"
    }
  }, [_vm._v("The Coevolutionary Perspective")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780804787161_06_ch1#sec2"
    }
  }, [_vm._v("The Development of the Coevolutionary Perspective")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780804787161_07_ch2"
    }
  }, [_vm._v("2. PARASITISM, GRAZING, AND PREDATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780804787161_07_ch2#sec3"
    }
  }, [_vm._v("Modes of Feeding")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780804787161_07_ch2#sec4"
    }
  }, [_vm._v("Specialization on Hosts and Prey")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780804787161_07_ch2#sec5"
    }
  }, [_vm._v("Patterns of Defense")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780804787161_07_ch2#sec6"
    }
  }, [_vm._v("Ecological Genetics of Coevolution in Antagonists")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780804787161_07_ch2#sec7"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_08_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. COMPETITION AND COEVOLUTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_08_ch3#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inferred Competition")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_08_ch3#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inferred Coevolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_08_ch3#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Probability of Encounter")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_08_ch3#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Competition for Mutualists")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_08_ch3#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Competitive Hierarchies")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_08_ch3#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nonhierarchies")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_08_ch3#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_09_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. ANTAGONISM AND MUTUALISM")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_09_ch4#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mutualism from Antagonism")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_09_ch4#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unit of Interaction")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_09_ch4#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_10_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. LIFE HISTORIES, HABITAT, AND MUTUALISM")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_10_ch5#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intermediate Survival and Disturbance")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_10_ch5#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stress and Mutualism")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_10_ch5#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Social Behavior and Mutualism")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_10_ch5#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_11_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. EVOLUTION OF MUTUAL DEPENDENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_11_ch6#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visitors and Hosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_11_ch6#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visitors")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_11_ch6#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_11_ch6#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_12_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. INTERACTION AND SPECIATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_12_ch7#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cospeciation")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_12_ch7#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempo in Cospeciation")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_12_ch7#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antagonism and Speciation")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_12_ch7#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mutualism and Speciation")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_12_ch7#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is Pollination a Special Case?")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_12_ch7#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_13_ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. THE INTERACTION STRUCTURE OF COMMUNITIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_13_ch8#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Evolutionary Units of Interaction")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_13_ch8#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Growth of Interactions")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_13_ch8#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ripple Effects of Interactions")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_13_ch8#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Patch Dynamics of Interactions")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_13_ch8#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_14_ref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REFERENCES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780804787161_15_ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb9f23a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780804787161_04_toc.vue
// module id = 63
// module chunks = 0